/**
 * WARNING: Ce fichier est nécessaire au bon fonctionnement de l'app !
 * Ne pas renommer / déplacer / supprimer le fichier
 * Ne pas renommer ou supprimer les variables exportées
 * Suivre les commentaires dans le code pour éditer le fichier
 */
import { gql } from '@apollo/client';

export const ProcessFragment = gql`
  fragment ProcessFragment on ExtendedProcess {
    # required fields (do not remove)
    projectId
    viewId
    metadata
    sessionId

    # additional fields
    # requested fields must match type definition at server/graphql/types/extended-process-type.mjs
    # add your custom fields here
    offerCode
    creatorUserRoles
    activeUserRoles
    brokerId
    companyName
    userCompany
    selfcareFloorViewId
  }
`;
